import './bootstrap.css'
import './App.css';

import React from 'react';

import tz_lookup from 'tz-lookup'
import moment from 'moment-timezone'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {Modal, Form, Tabs, Tab, ModalBody,Popover,OverlayTrigger} from 'react-bootstrap';
import {Button} from 'react-bootstrap';

import swal from 'sweetalert'

import LocationSearchInput from "./components/LocationSearchInput"


import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import prayTimes from './PrayTimes'
import hmoment from 'moment-hijri';
import * as DateConverter from "./services/date-convert.service";
import Proxy from "./components/proxy";
import * as PdfApiService from "./services/pdfapi.services";

import {isMobile,browserName} from 'react-device-detect';

import { getCountryName } from './services/dst.service';

import {isDST} from "./services/dst.service"

class App extends React.Component {


    carouselRef = React.createRef();
    tabsRef = React.createRef();
    tabsEventKeys = ["timezone", "prayer-method", "customize"]
    hijriMonths = ["Muharram", "Safar", "Rabi Al-Awwal", "Rabi Al-Thani", "Jumada Al-Awwal", "Jumada Al-Thani", "Rajab", "Sha`ban", "Ramadan", "Shawwal", "Dhul-Qa`dah", "Dhul-Hijjah"]

    responsive = {
        desktop: {
            breakpoint: {max: 3000, min: 1024}, items: 1, slidesToSlide: 1 // optional, default to 1.
        }, tablet: {
            breakpoint: {max: 1024, min: 464}, items: 1, slidesToSlide: 1 // optional, default to 1.
        }, mobile: {
            breakpoint: {max: 464, min: 0}, items: 1, slidesToSlide: 1 // optional, default to 1.
        }
    };

    constructor(props) {
      

        super(props);
        this.prayTimesTableRef = React.createRef();
        this.loadPrayertimesStateFromLocalStroage();

        if(this.state.country === undefined || this.state.state_obtained === undefined || this.state.crversion === undefined)
        {
             localStorage.removeItem('prayertimes_state');
             this.state = this.getDefaultState();
        }
        
        /*this.state = {
            convertedDatesMap: null,

            lat: 0,
            lng: 0,
            timeZone: 0,
            format: '12hNS',
            address: '',
            dst: 0,
            method: 'ISNA',
            asrMethod: 'Standard',
            style: 'style1',

            dateMode: "greg",
            month: null,
            latLng: undefined,
            year: null,
            monthName: "Jan",
            newAddress: '',

            prayTimesTableRendered: false,
            showModal: true,
            currentTab: 0,

            customTitle: "PRAYER TIMES",
            customFooter: "",
            customLogo: process.env.PUBLIC_URL + "/images/logo-header.webp?ver=" + window.settings.ver,
            monthDetail: [],
            showDownloadModal: false,
            headerErrorMsg: null,
        };*/
        
    }

    handleMonthNameAndYear = (month) => {
        //console.log(month);
        if (month > 12) {
            this.setState({
                monthName: this.hijriMonths[month - 13], year: parseInt(hmoment().format("iYYYY"))
            })
        } else {
            this.setState({
                monthName: moment(month, 'M').format("MMMM"), year: moment().format("YYYY")
            })
        }
    }

    componentDidMount() {
        //this.setState(JSON.parse(localStorage.getItem('prayertimes_state')));
       
        
        this.setState({currentTab: 0});
      
        if (!this.state.month) {
            this.setState({
                month: moment().format("M"), monthName: moment().format("MMMM"), year: moment().format("YYYY")
            })
        } else {
            this.handleMonthNameAndYear(this.state.month);
        }

    }

    loadPrayertimesStateFromLocalStroage(){

        let localStorageState = localStorage.getItem('prayertimes_state') != "" ? JSON.parse(localStorage.getItem('prayertimes_state')) : null;
        
        if(localStorageState != null)
        {
           
        
            this.state = {
                convertedDatesMap: localStorageState.convertedDatesMap,

                lat: localStorageState.lat,
                lng: localStorageState.lng,
                timeZone: localStorageState.timeZone,
                format: localStorageState.format,
                address: localStorageState.address,
                dst: localStorageState.dst,
                method: localStorageState.method,
                asrMethod: localStorageState.asrMethod,
                style: localStorageState.style,

                dateMode: localStorageState.dateMode,
                month: localStorageState.month,
                latLng: localStorageState.latLng,
                year: localStorageState.year,
                monthName: localStorageState.monthName,
                newAddress: localStorageState.newAddress,
                country: localStorageState.country,
                state_obtained: localStorageState.state_obtained,
                crversion:localStorageState.crversion,

                prayTimesTableRendered: localStorageState.prayTimesTableRendered,
                showModal: localStorageState.showModal,
                currentTab: localStorageState.currentTab,

                customTitle: localStorageState.customTitle,
                customFooter: localStorageState.customFooter,
                customLogo: localStorageState.customLogo,
                monthDetail: localStorageState.monthDetail,
                showDownloadModal: false,
                headerErrorMsg: localStorageState.headerErrorMsg,
            };
        }
        else
        {
            this.state = this.getDefaultState()
        }
    }

     getDefaultState=()=> {
        return {
                convertedDatesMap: null,

                lat: 0,
                lng: 0,
                timeZone: 0,
                format: '12hNS',
                address: '',
                dst: 0,
                method: 'ISNA',
                asrMethod: 'Standard',
                style: 'style1',

                dateMode: "greg",
                month: null,
                latLng: undefined,
                year: null,
                monthName: "Jan",
                newAddress: '',
                country:'',
                state_obtained:'',

                prayTimesTableRendered: false,
                showModal: true,
                currentTab: 0,

                customTitle: "PRAYER TIMES",
                customFooter: "",
                customLogo: process.env.PUBLIC_URL + "/images/logo-header.webp?ver=" + window.settings.ver,
                monthDetail: [],
                showDownloadModal: false,
                headerErrorMsg: null,
                crversion:"03.20.2025"
            };
    }

    handleModalPreview = () => {
        this.setState({showModal: false});
        this.handleSubmit();
    }
    handleModalNext = () => {
        this.setState({currentTab: (this.state.currentTab + 1) % this.tabsEventKeys.length});

        this.carouselRef.goToSlide(parseInt(this.state.style[this.state.style.length - 1]) - 1)
    }
    handleModalTabSelect = (key) => {
        this.setState({currentTab: this.tabsEventKeys.findIndex((k) => k == key)});

        this.carouselRef.goToSlide(parseInt(this.state.style[this.state.style.length - 1]) - 1)
    }
    handleCarouselChange = (e) => {
        this.setState({style: 'style' + (this.carouselRef.state.currentSlide + 1)})
    }
    // handleClose = () => {
    //     // 
    //     this.carouselRef.goToSlide(0);
    // }
    handleSettings = () => {
        this.setState({showModal: true});
    }

    handleSubmit = () => {
        if (this.state.latLng === undefined) {
            swal("Error!", "Please enter your City or Zip Code first.", "warning");
        } else {
            this.setState({
                prayTimesTableRendered: true,
                lat: this.state.latLng.lat,
                lng: this.state.latLng.lng,
                address: this.state.newAddress
            });
        }
    }

    handleSearchChange = (value) => {
        this.setState({
            prayTimesTableRendered: false, latLng: undefined, newAddress: ''
        });
    }

    handleSelect = (platLng, paddress) => {

        const tz = tz_lookup(platLng.lat, platLng.lng);
        this.setState({
            latLng: platLng,
            newAddress: paddress,
            timeZone: moment.tz.zone(tz).utcOffset(moment.tz("2025-01-01", tz)) / -60
        });
        getCountryName(platLng.lat, platLng.lng).then(countrystate =>  this.setState({ country:countrystate.country, state_obtained:countrystate.state }) );
    }


    componentDidUpdate() {
        localStorage.setItem('prayertimes_state', JSON.stringify(this.state))
    }

    handleMonth = (event) => {
        let month = event.target.value;
        this.setState({month: month});
        this.handleMonthNameAndYear(month);
        if (month > 12) {
            this.setState({
                dateMode: "hijri"
            })
        } else {
            this.setState({
                dateMode: "greg"
            })
        }
    }

    getPrayerTimeDetailsInJson = (monthDetail) => {

        const monthDataInJson = [];
        for (let currentDate of monthDetail) {
           
            prayTimes.setMethod(this.state.method);
            prayTimes.adjust({asr: this.state.asrMethod});

            let offset = 0;

            let the_date = new Date(moment(currentDate.greg, 'MMM DD YYYY, ddd').format('YYYY-MM-DD'))
            
            if(isDST(this.state.country,this.state.state_obtained,the_date))
            {
                //offset = this.state.dst * 60;
                offset = 1 * 60;
            }
     
            
            prayTimes.tune({
                sunrise: offset, sunset: offset, fajr: offset, dhuhr: offset, asr: offset, maghrib: offset, isha: offset
            });
            const times = prayTimes.getTimes(currentDate.greg, [this.state.lat, this.state.lng], this.state.timeZone, 0, this.state.format);
            let monthDate = moment(currentDate.greg, 'MMM DD, ddd').format('D');
            let date = currentDate.hijri;
            if (this.state.dateMode === "hijri") {
                monthDate = currentDate.hijri;
                date = moment(currentDate.greg, 'MMM DD, ddd').format('MMM DD');
            }
            const singleMonthDetail = {
                RMDN: monthDate,
                DAY: moment(currentDate.greg, 'MMM DD, ddd').format('ddd'),
                DATE: date,
                FJR: times.fajr,
                SUNRISE: times.sunrise,
                DHR: times.dhuhr,
                ASR: times.asr,
                MGB: times.maghrib,
                ISH: times.isha
            }
            monthDataInJson.push(singleMonthDetail);
        }

        return monthDataInJson;
    }

    handleDownloadPdf = (monthDetail) => {
        let logoUrl = this.state.customLogo;
        if (logoUrl.indexOf("/images/logo-header.webp?") !== -1) {
            logoUrl = "";
        }
        const prayerTimesData = {
            backgroundurl: `https://www.islamicity.org/print-prayer-times/images/${this.state.style}/main_bg.jpg?ver=${window.settings.ver}`,
            logourl: logoUrl,
            selectedmonth: this.state.monthName,
            userheaderdata: `<p>${this.state.monthName} ${this.state.year}<br/> ${this.state.address}</p>`,
            prayermethod: this.state.customTitle,
            calendarDays: this.getPrayerTimeDetailsInJson(monthDetail),
            footer: this.state.customFooter,
        }

        PdfApiService.getPdfFromApi(prayerTimesData)
            .then(rep => {
                console.log(rep)
                if(rep.autoClick){
                    document.getElementById(rep.linkId).click();
                }
                else{
                    this.setState({
                        showDownloadModal: false
                    });
                    window.location.href = "display.php?key=" + rep.displaykey;
                    // const link = document.createElement('a');
                    // link.href =  "display.php?key=" + rep.displaykey;
                    // link.setAttribute('target','_blank');
                    // link.setAttribute('id', rep.displaykey);
                    // document.body.appendChild(link);
                    // document.getElementById(rep.displaykey).click();

                }
                this.setState({
                    showDownloadModal: false
                })
            }).catch(error => {
            this.setState({
                showDownloadModal: false
            });
        })
    }
    handlePrintTable = (prayTimesTable) => {
        let modalStatus = true;
        if (isMobile && browserName.toLowerCase().includes("safari")) {
            modalStatus = false;
        }
        this.setState({
            showDownloadModal: modalStatus
        })

        if (this.state.month <= 12) {
            DateConverter.getGregorianMonthDetail(moment().format("YYYY"), this.state.month)
                .then(response => {
                    this.handleDownloadPdf(response);
                }).catch(error => {
                    console.log(error);
                    this.setState({
                        showDownloadModal: false
                    });
                    setTimeout(() => {
                        alert("Sorry download is generated an error! Please try again");
                    }, 1000);
                    });
        } else {
           
            DateConverter.getHijriMonthDetail(this.state.year, this.state.month - 12)
                .then(response => {
                    this.handleDownloadPdf(response);
                }).catch(error => {
                   console.log(error);
                   this.setState({
                        showDownloadModal: false
                   });
                   setTimeout(() => {
                    alert("Sorry download is generated an error! Please try again");
                   }, 1000);
                   
                });
        }


    }

    handleHeader = (value) => {
        if (value.length > 90) {
            this.setState({
                headerErrorMsg: "Please shorten your organization name to be less than 90 characters."
            })
        } else {
            this.setState({
                customTitle: value, headerErrorMsg: null
            })
        }
    }

    

    render() {
        let prayTimesTable;
        let startDate;
        let popover_position = window.innerWidth < 700 ? "auto" : "right";
        let popover_custom_logo_position = window.innerWidth < 700 ? "bottom" : "right";
   
        const   dstPopoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title="DST Setting">
                <p className='p-3 pb-0 dst-message'><strong>DST:</strong> Leave the DST setting on Standard at all times so we can factor in the Daylight Saving Zone for your locality automatically.  
                    <br/><br/>In some rare instances, you may need to use +1 or -1 to adjust timings accordingly. 
                    
                    </p>
                  
            </Popover>
        );

        const   customizeDesignPopoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title="Customize Design Setting">
                <p className='p-3 pb-0 dst-message'>
                    <strong>Customize Design:</strong> The customization options allow you to personalize the application to suit your organization's identity or personnel communication preferences.
                </p>
                  
            </Popover>
        );

        const   customLogoPopoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title="Custom Logo Setting">
                <p className='p-3 pb-0 dst-message'>
                    <strong>Custom Logo:</strong> Insert the URL of the image representing your organization, masjid, or personnel logo. (Optional: You may add any image if desired.)
                    
                    </p>
                  
            </Popover>
        );

        const   institutionNamePopoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title="Masjid/Institution Name Setting">
                <p className='p-3 pb-0 dst-message'>

                    <strong>Masjid/Institution Name:</strong> Enter the preferred name or designation that you wish to be displayed. E.g. Masjid Noor or Mustafa Islam Family
                    
                    </p>
                  
            </Popover>
        );

        const   footerPopoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title="Footer Setting">
                <p className='p-3 pb-0 dst-message'>

                   <strong>Footer:</strong> Input any message you'd like to appear in the footer section of the print. E.g. Enjoin Prayer on your household, and do keep observing it. Quran 20:132
                    
                    </p>
                  
            </Popover>
        );

        if (this.state.prayTimesTableRendered) {

            let logoUrl = this.state.customLogo;
            if (logoUrl.trim().length <= 0) {
                logoUrl = process.env.PUBLIC_URL + "/images/logo-header.webp?ver=" + window.settings.ver;
            }
            prayTimesTable = <Proxy style={this.state.style}
                                    ref={this.prayTimesTableRef}
                                    date={startDate}
                                    monthName={this.state.monthName}
                                    month={this.state.month}
                                    monthDetail={this.state.monthDetail}
                                    dateMode={this.state.dateMode}
                                    lat={this.state.lat}
                                    year={this.state.year}
                                    lng={this.state.lng}
                                    convertedDates={this.state.convertedDatesMap}
                                    timeZone={this.state.timeZone}
                                    address={this.state.address}
                                    country={this.state.country}
                                    state_obtained={this.state.state_obtained}
                                    dst={this.state.dst}
                                    method={this.state.method}
                                    asrMethod={this.state.asrMethod}
                                    format={this.state.format}
                                    customLogo={logoUrl}
                                    customTitle={this.state.customTitle}
                                    customFooter={this.state.customFooter}/>
        } else {
            prayTimesTable = <div/>
        }


        return (<div>
            <Container className="header">
                <Row>
                    <Col>
                        <div className="text-center p-2">
                            <a href="https://www.islamicity.org"><img
                                src={process.env.PUBLIC_URL + "/images/logo-header.webp?ver=" + window.settings.ver}
                                alt="Islami City Logo"/></a>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col><h3 className="text-center p-2">Prayer Times</h3></Col>
                </Row>
                <Row className="p-2">

                    <Col md={{span: 3, offset: 4}} sm={10} xs={10}>
                        <button className="btn btn-primary" onClick={this.handleSettings}>Settings</button>
                    </Col>
                    <Col sm={2} xs={2}>
                        <button className={`btn btn-success ${!this.state.prayTimesTableRendered ? 'hidden' : ''}`}
                                onClick={() => this.handlePrintTable(prayTimesTable)}><span style={{ "white-space": "nowrap"}} >Print PDF</span>
                        </button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    </Col>
                </Row>
            </Container>

            <Modal show={this.state.showModal} centered>

                <Modal.Body>
                    <Tabs ref={this.tabsRef} onSelect={this.handleModalTabSelect}
                          activeKey={this.tabsEventKeys[this.state.currentTab]} defaultActiveKey="timezone"
                          className="mb-3 nav-fill" variant='pills'>
                        <Tab eventKey="timezone" title="Timezone">
                            <h6>Enter City or Zip Code:</h6>
                            <LocationSearchInput address={this.state.newAddress} onChange={this.handleSearchChange}
                                                 onSelect={this.handleSelect}/>
                            <h6 className="pt-3">Select Calendar Month:</h6>
                            <Form.Control as="select" value={this.state.month} onChange={this.handleMonth}>
                                <optgroup label="Select a Gregorian Month">
                                    {moment.months().map((monthName, monthNumber) => {
                                        monthNumber += 1
                                        let currentMonthNumber = parseInt(moment().format("M"));
                                        let showMonth = (monthNumber - currentMonthNumber < 0 || monthNumber - currentMonthNumber > 1);
                                        return (showMonth === false ? <option value={monthNumber}
                                        >{monthName+ " "+moment().format("YYYY")}</option> : "")
                                    })}
                                </optgroup>
                                <optgroup label="Select a Hijri Month">
                                    {this.hijriMonths.map((monthName, monthNumber) => {
                                        monthNumber += 1
                                        let currentMonthNumber = parseInt(hmoment().format("iM"));
                                        let showMonth = (monthNumber - currentMonthNumber < 0 || monthNumber - currentMonthNumber > 1);
                                        return (showMonth === false ? <option value={monthNumber + 12}
                                        >{monthName+ " "+hmoment().format("iYYYY")}</option> : "")
                                    })}
                                </optgroup>

                                <optgroup label={"All Greg Months "+moment().format("YYYY")}>
                                    {moment.months().map((monthName, monthNumber) => {
                                        monthNumber += 1
                                        return <option value={monthNumber}
                                        >{monthName+ " "+moment().format("YYYY")}</option>
                                    })}
                                </optgroup>
                                <optgroup label={"All Hijri Months " +hmoment().format("iYYYY")}>
                                    {this.hijriMonths.map((monthName, monthNumber) => {
                                        monthNumber += 1

                                        return <option value={monthNumber + 12}
                                        >{monthName+ " "+hmoment().format("iYYYY")}</option>
                                    })}
                                </optgroup>
                            </Form.Control>
                            <p className="p-3">Time zone: {this.state.timeZone + parseInt(this.state.dst)}</p>
                            <Form.Group as={Row}>
                                <Form.Label className='hidden' column sm="3">DST: 
                                 
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement={popover_position}
                                        overlay={dstPopoverHoverFocus}
                                        >
                                     <span className='p-2 cursor-pointer'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
</svg></span> 
                                    </OverlayTrigger>
                              
                                </Form.Label>
                                {/* Hidden DST Form becuase it is calculated by the system. Changed By Nazrul 02/27/2025 */}
                                <Col sm="9" className='hidden'>
                                    <Form.Control as="select" value={this.state.dst}
                                                  onChange={e => this.setState({dst: e.target.value})}>
                                        <option value="0">Standard</option>
                                        <option value="1">+1</option>
                                        {/* <option value="-1">-1</option>  commented by Nazrul 02/27/2025 */}
                                    </Form.Control>
                                </Col>
                            </Form.Group>
                        </Tab>
                        <Tab eventKey="prayer-method" title="Prayer Method">
                            <h6>Select Prayer time method:</h6>
                            <Form.Control as="select" value={this.state.method}
                                          onChange={e => this.setState({method: e.target.value})}>
                                <option value="ISNA">Islamic Society of North America (ISNA)</option>
                                <option value="MWL">Muslim World League (MWL)</option>
                                <option value="Egypt">Egyptian General Authority of Survey</option>
                                <option value="Makkah">Umm al-Qura University, Makkah</option>
                                <option value="Karachi">University of Islamic Sciences, Karachi</option>
                                <option value="Jafari">Shia Ithna-Ashari (Jafari)</option>
                                <option value="Tehran">Institute of Geophysics, University of Tehran</option>
                            </Form.Control>
                            <h6 className="pt-3">Select Asr Method:</h6>

                            <Form.Control as="select" value={this.state.asrMethod}
                                          onChange={e => this.setState({asrMethod: e.target.value})}>
                                <option value="Standard">Standard</option>
                                <option value="Hanafi">Hanafi</option>
                            </Form.Control>
                        </Tab>
                        <Tab eventKey="customize" title="Customize">
                            <h6>Customize Design</h6>
                            <p>Template: <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement={popover_position}
                                        overlay={customizeDesignPopoverHoverFocus}
                                        >
                                     <span className='p-2 cursor-pointer'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
</svg></span> 
                                    </OverlayTrigger></p>
                            <Carousel ref={(el) => {
                                this.carouselRef = el
                            }} afterChange={this.handleCarouselChange}
                                      swipeable={true}
                                      draggable={true}
                                      showDots={false}
                                      infinite={false}
                                      focusOnSelect={true}
                                      arrows={true} //show the slider navigation 07/06/2023 11:34 AM LA time
                                      centerMode={true}
                                      shouldResetAutoplay={false}
                                      responsive={this.responsive}>
                                
                                <img src={"images/style1/thumbnail.jpg"}/>
                                <img src={"images/style2/thumbnail.jpg"}/>
                                <img src={"images/style3/thumbnail.jpg"}/>
                                <img src={"images/style4/thumbnail.jpg"}/>
                                <img src={"images/style5/thumbnail.jpg"}/>
                                <img src={"images/style6/thumbnail.jpg"}/>

                                
                                
                            </Carousel>
                            <p className="mt-3 mb-2">Custom Logo: <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement={popover_custom_logo_position}
                                        overlay={customLogoPopoverHoverFocus}
                                        >
                                     <span className='p-2 cursor-pointer'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
</svg></span> 
                                    </OverlayTrigger>
                                    
                             </p>
                            <Form.Control type="text" value={this.state.customLogo}
                                          onChange={e => this.setState({customLogo: e.target.value})}/>
                            {this.state.headerErrorMsg &&
                                <span style={{"color": "red"}}>{this.state.headerErrorMsg}</span>}
                            <p className="mt-3 mb-2">Masjid/Institution Name (Optional): <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement={popover_position}
                                        overlay={institutionNamePopoverHoverFocus}
                                        >
                                     <span className='p-2 cursor-pointer'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
</svg></span> 
                                    </OverlayTrigger></p>
                            <Form.Control type="text" value={this.state.customTitle}
                                          onChange={e => this.handleHeader(e.target.value)}/>

                            <p className="mt-3 mb-2">Footer (Optional): <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement={popover_position}
                                        overlay={footerPopoverHoverFocus}
                                        >
                                     <span className='p-2 cursor-pointer'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
</svg></span> 
                                    </OverlayTrigger>
                                    
                                    </p>
                            <Form.Control type="text" value={this.state.customFooter}
                                          onChange={e => this.setState({customFooter: e.target.value})}/>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className={"mr-auto"} sytle={{float: "right"}}
                            onClick={this.handleModalPreview}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={this.handleModalPreview}>
                        Preview
                    </Button>
                    {this.state.currentTab !== 2 && (<Button variant="primary" onClick={this.handleModalNext}>
                        Next
                    </Button>)}
                </Modal.Footer>
            </Modal>
            <Modal show={this.state.showDownloadModal} centered>
                <ModalBody>
                    Your file is downloading...
                </ModalBody>
            </Modal>
           
            <div className="content">
                {prayTimesTable}
            </div>
        </div>);
    }
}

export default App;
